import { createStore } from 'Vuex'
function getNumDays(state, colName=null) {
    let getdata = new Date()

    let date = state.Details.Check_in ? new Date(state.Details.Check_in) : getdata;
    let day = `${(date.getDate())}`.padStart(2, '0');
    let month = `${(date.getMonth() + 1)}`.padStart(2, '0');
    let year = date.getFullYear();
    //    out date
    let dateout = state.Details.Check_out ? new Date(state.Details.Check_out) : getdata;
    let dayout = `${(date.getDate())}`.padStart(2, '0');
    let monthout = `${(date.getMonth() + 1)}`.padStart(2, '0');
    let yearout = date.getFullYear();

    var diff = (dateout.getTime() - date.getTime()) / (1000 * 60 * 60 * 24);
    return diff;
  }
const store = createStore({
    state: {
        current: 0,//current  STEPS
        ListRooms: [],//list the rooms
        igv:0,
        subtotal:0,
        total: 0,
        night:0,
        Details: {
            adults: 2,
            children: 0,
            Check_in: '',
            Check_out: '',
        },
        Contact:{
          first_name: '',
          last_name: '',
          email: '',
          number: '',
          country: '',
          adicional: '',
          term: '',
        }
    },
    getters: {
        NumDays: function (state) {
             let a= getNumDays(state);
             state.night=a;
            return a;
        },
        TotalPrice: function (state ) {
            let total = 0;
            state.ListRooms.forEach(items => {
                total += parseInt(items.acf.price)
            })

            let a= getNumDays(state);
            let igv=(total *a)*0.05 ;
            state.igv=igv;
            state.subtotal= (total *a);
            return state.total = (total *a) + parseInt(igv) ;
        },
    },
    mutations: {
        ADD_LIST_ROOMS(state, ListRooms) {
            state.ListRooms.push(ListRooms)
        },
        DELETE_LIST_ROOMS(state, index) {
            state.ListRooms.splice(index, 1);

        },
        // ///CORRENT STEPS 
        PLUS_CURRENT(state, item) {
            state.current++;
        },
        MINUS_CURRENT(state, item) {
            state.current--;
            if(item.clearrom){
                state.current=0;
            }
        },
        // Add Dates-in and date-out
        ADD_DATE(state, dates) {
            let date_in =dates[0]?new Date(dates[0]):new Date(dates[1]+1);
              
            let date_out =dates[1]? new Date(dates[1]):new Date(dates[0]+1);
    
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            state.Details.Check_in = date_in.toLocaleDateString('en', options);
            state.Details.Check_out = date_out.toLocaleDateString('en', options);
        },
        // Datan list constact 
        ADD_CONTACT(state,data){
             state.Contact=data;
        }
    },
    actions: {
        addListRooms({ commit }, ListRooms) {
            commit('ADD_LIST_ROOMS', ListRooms)
        },
        deleteListRooms({ commit }, index) {
            commit('DELETE_LIST_ROOMS', index)
        },
        // ACTION CORRENT
        plusCurrent({ commit }, index) {
            commit('PLUS_CURRENT', index)
        },
        minCurrent({ commit }, index,has) {
            commit('MINUS_CURRENT', index,has)
        },
        /// add AddDates
        AddDates({ commit }, dates) {
            commit('ADD_DATE', dates)
        },
       // Datan list constact 
       AddContact({ commit },data){
           commit('ADD_CONTACT', data)
       }

    },
})
export default store